import { Avatar, AvatarProps } from '@mui/material'
import { ImageURL } from '@singcolor/grpc-client/src/singcolor-proto/ts/photo_entity_pb'
import React from 'react'

export type UserThumbnailProps = {
  size: string
  imageURLs: ImageURL.AsObject | undefined
  /** default: circular */
  variant?: AvatarProps['variant']
}

export const UserThumbnail: React.FC<UserThumbnailProps> = ({ size, imageURLs, variant }) => {
  const srcSet: string | undefined = (() => {
    if (!imageURLs) return
    const urls: string[] = []
    if (imageURLs.extraSmall) urls.push(`${imageURLs.extraSmall} 32w`)
    if (imageURLs.small) urls.push(`${imageURLs.small} 48w`)
    if (imageURLs.medium) urls.push(`${imageURLs.medium} 96w`)
    if (imageURLs.large) urls.push(`${imageURLs.large} 192w`)
    if (urls.length === 0) return
    return urls.join()
  })()

  return <Avatar variant={variant ?? 'circular'} sx={{ width: size, height: size }} srcSet={srcSet} />
}
